import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { BurgerMenu, NavItem } from "../../atoms";
import { SUPPORT_MAILTO, SUPPORT_TELEGRAM } from "@shared/config/env";

const MenuLink = styled(Link)`
  color: #FEFFFF;
  text-decoration: none;

  &:hover {
      color: rgb(194, 143, 90);
  }
`;

const ExternalLink = styled.a`
  color: #FEFFFF;
  text-decoration: none;

  &:hover {
      color: rgb(194, 143, 90);
  }
`;

export const Header: React.FC = () => {
    const { pathname } = useLocation();
    const [isScrolled, setIsScrolled] = useState(false);

    const isHomePage = pathname === "/";
    const showGlass = !isHomePage && isScrolled;

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };

        handleScroll();

        window.addEventListener("scroll", handleScroll, {
            passive: true,
        });

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [pathname]);

    const renderMenu = () => (
        <NavContainer id="navbar-multi-level">
            <NavList>
                <NavItem>
                    <ExternalLink href={SUPPORT_MAILTO}>
                        Сотрудничество
                    </ExternalLink>
                </NavItem>

                <NavItem>
                    <ExternalLink
                        href={SUPPORT_MAILTO}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Поддержка
                    </ExternalLink>
                </NavItem>

                <NavItem>
                    <MenuLink to="/about">О нас</MenuLink>
                </NavItem>
            </NavList>
        </NavContainer>
    );

    return (
        <>
            <GlassLayer $visible={showGlass} aria-hidden="true" />

            <Root>
                <HeaderInner>
                    <LogoLink as={Link} to="/" aria-label="Plumme — главная">
                        <Logo src="/logo.png" alt="Plumme" />
                    </LogoLink>

                    <Menu>{renderMenu()}</Menu>

                    <BurgerMenu />
                </HeaderInner>
            </Root>
        </>
    );
};

const GlassLayer = styled.div<{ $visible: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 98;

  /* 24px сверху + 32px контент + 24px снизу */
  height: 80px;

  pointer-events: none;

  background: ${({ $visible }) =>
    $visible ? "rgba(22, 56, 80, 0.72)" : "transparent"};

  -webkit-backdrop-filter: ${({ $visible }) =>
    $visible ? "blur(8px) saturate(140%)" : "none"};

  backdrop-filter: ${({ $visible }) =>
    $visible ? "blur(8px) saturate(140%)" : "none"};

  border-bottom: 1px solid
    ${({ $visible }) =>
    $visible ? "rgba(255, 255, 255, 0.12)" : "transparent"};

  box-shadow: ${({ $visible }) =>
    $visible ? "0 10px 36px rgba(4, 18, 28, 0.12)" : "none"};

  opacity: ${({ $visible }) => ($visible ? 1 : 0)};

  transition:
    opacity 300ms ease,
    background-color 300ms ease,
    border-color 300ms ease,
    box-shadow 300ms ease,
    backdrop-filter 300ms ease;
`;

const Root = styled.header`
    position: fixed;
    //top: 0;
    //right: 0;
    //left: 0;
    z-index: 99;

    width: 100%;
    padding: 24px 0;
    box-sizing: border-box;

    transition:
            background-color 300ms ease,
            border-color 300ms ease,
            box-shadow 300ms ease,
            backdrop-filter 300ms ease;
`;

const HeaderInner = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    width: 100%;
    min-height: 32px;
    margin: 0;
    //padding: 0 0 0 1.5rem;
    box-sizing: border-box;

    @media (min-width: 900px) {
        justify-content: flex-start;
        gap: 100px;
    }

    @media (min-width: 1024px) {
        gap: 300px;
        //padding-left: max(
        //        25px,
        //        calc(16vw + env(safe-area-inset-left))
        //);
    }
`;


const Menu = styled.nav`
    display: none;

    @media (min-width: 900px) {
        display: flex;
        flex: 1;
        min-width: 0;
    }
`;

const LogoLink = styled.a`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const Logo = styled.img`
  height: 32px;
`;

const NavContainer = styled.div`
    width: 100%;

    @media (min-width: 900px) {
        position: static;
        display: block;
        background: none;
    }
`;



const NavList = styled.ul`
    display: flex;
    align-items: center;
    gap: clamp(60px, 10vw, 200px);

    margin: 0;
    padding: 0;
    list-style: none;
`;